const checkIfSwAvailable = async ({
	isActive,
}: {
	isActive?: boolean;
}): Promise<boolean> => {
	if (
		"serviceWorker" in navigator &&
		"getRegistrations" in navigator.serviceWorker
	) {
		try {
			const registrations = await navigator.serviceWorker.getRegistrations();
			if (isActive) {
				const activatedRegistrations = registrations.filter(
					registration =>
						registration.active !== null &&
						registration.active.state === "activated",
				);
				return activatedRegistrations.length > 0;
			}
			return registrations.length > 0;
		} catch (error) {
			console.error("Error getting service worker registrations:", error);
		}
	} else {
		console.log("Service workers are not supported in this browser.");
	}
	return false;
};

const handleUnregisterServiceWorkers = () => {
	if (
		"serviceWorker" in navigator &&
		"getRegistrations" in navigator.serviceWorker
	) {
		navigator.serviceWorker
			.getRegistrations()
			.then((registrations) => {
				if (registrations.length > 0) {
					registrations.forEach((registration) => {
						registration.unregister();
					});
				}
			})
			.catch((error) => {
				console.error("Error getting service worker registrations:", error);
			});
	} else {
		console.log("Service workers are not supported in this browser.");
	}
};

export { checkIfSwAvailable, handleUnregisterServiceWorkers };
